import { de, enCA, enGB, enUS, es, fr, Locale } from "date-fns/locale";

export const getCalendarLocale = (locale: string): Locale => {
  switch (locale) {
    case "es-ES":
    case "es":
      return es;
    case "en-GB":
      return enGB;
    case "en-CA":
      return enCA;
    case "en-US":
    case "us":
    case "en":
      return enUS;
    case "de-DE":
    case "de":
      return de;
    case "fr-FR":
    case "fr":
      return fr;
    default:
      return enGB;
  }
};
